<template>
  <v-btn icon flat small @click="goRoute">
    <v-tooltip bottom>
      <v-icon slot="activator" color="primary">picture_as_pdf</v-icon>
      <span>Ver contrato</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    goRoute () {
      window.open(this.item.asset.url, '_blank')
    }
  }
}
</script>
